@if (item().state === 'live') {
  {{ liveText(item().type) }}
} @else {
  {{ formatTime(item().remainingSeconds) }}
}
